import getGlobalDiscountsMenu from './getGlobalDiscountsMenu';

const getGlobalDiscountsTotalAmount = state =>
  getGlobalDiscountsMenu(state)?.totalAmount || null;

export default getGlobalDiscountsTotalAmount;
